import {VatIdFragment, WixCommonVatType} from '../../../../gql/graphql';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {VatId, VatType as VatTypeV2} from '@wix/auto_sdk_ecom_cart-v-2';

export class VatIdModel {
  public id?: string;
  public type?: VatType;

  constructor(params: VatIdModel) {
    this.id = params.id;
    this.type = params.type;
  }

  public static fromCheckoutV1(vatId?: VatIdFragment | null) {
    if (!vatId) {
      return undefined;
    }
    return new VatIdModel({
      id: mapNullToUndefined(vatId.id),
      type: vatId.type ? vatIdTypeMapV1[vatId.type] : /* istanbul ignore next */ undefined,
    });
  }

  public static fromCartV2(vatId?: VatId) {
    if (!vatId) {
      return undefined;
    }
    return new VatIdModel({
      id: mapNullToUndefined(vatId?._id),
      type: vatId.type ? vatIdTypeMapV2[vatId.type] : /* istanbul ignore next */ undefined,
    });
  }
}

export enum VatType {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  UNSPECIFIED = 'UNSPECIFIED',
}

export const vatIdTypeMapV1: Record<WixCommonVatType, VatType> = {
  [WixCommonVatType.CPF]: VatType.CPF,
  [WixCommonVatType.CNPJ]: VatType.CNPJ,
  [WixCommonVatType.UNSPECIFIED]: VatType.UNSPECIFIED,
};

export const vatIdTypeMapV2: Record<VatTypeV2, VatType> = {
  [VatTypeV2.CPF]: VatType.CPF,
  [VatTypeV2.CNPJ]: VatType.CNPJ,
  [VatTypeV2.UNSPECIFIED]: VatType.UNSPECIFIED,
};
